<form class="ui form" (ngSubmit)="onSubmit()" #form="ngForm">
    <ng-container *ngIf="hasFile; else fileUploader">
        <div class="file">
            <div class="left"><mat-icon svgIcon="attach" class="margin-right-1"></mat-icon> {{ filename }}</div>
            <img class="cancel" appIcon="CrossGreyUiOutline" (click)="cancelUpload()" />
        </div>
    </ng-container>
    <ng-template #fileUploader>
        <app-file-drop
            [externalErrors]="errors"
            [@pulse]="noFile"
            (@pulse.done)="onAnimationFinish()"
            [allowedTypes]="['.csv', '.tsv', '.ods', '.xlsx', '.xls']"
            [showAllowableTypes]="true"
            (filesSelected)="onFileChange($event)"
        >
        </app-file-drop>
    </ng-template>
    <input name="fileUploaded" required type="hidden" [(ngModel)]="hasFile" />
</form>
